/** ConeTwistJoint3D parser: the Joint3D surface plus `swing_span` and `twist_span`. */
import { writtenScalarSlotValue } from '../../../../godot/variant/variantBool.js';
import { parseJoint3D } from '../joint3d/parser';
export function parseConeTwistJoint3D(heading, properties) {
    return {
        ...parseJoint3D(heading, properties),
        swing_span: writtenScalarSlotValue(properties.swing_span),
        twist_span: writtenScalarSlotValue(properties.twist_span),
    };
}
//# sourceMappingURL=parser.js.map